import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class AvslutaVirkesorderCommand extends BasicCommand<AvslutaVirkesorderCommand> {
    get primaryKey(): IPrimaryKey<AvslutaVirkesorderCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AvslutaVirkesorderCommand";
    constructor(init: (instance: AvslutaVirkesorderCommand) => void) {
        super(AvslutaVirkesorderCommand.$type, AvslutaVirkesorderCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
